<script setup lang="ts">
import { heroPills, heroStats } from '../data/landing.content'
</script>

<template>
  <section class="wl-hero" id="inicio">
    <!-- Anillos geometricos -->
    <div class="wl-hero-geo" aria-hidden="true">
      <div class="wl-hero-geo-ring wl-hero-geo-ring-1"></div>
      <div class="wl-hero-geo-ring wl-hero-geo-ring-2"></div>
      <div class="wl-hero-geo-ring wl-hero-geo-ring-3"></div>
    </div>

    <!-- Marca de agua -->
    <div class="wl-hero-watermark" aria-hidden="true">APPMISIONATE</div>

    <!-- Fotografia -->
    <div class="wl-hero-img-panel">
      <picture>
        <source srcset="/images/hero.webp" type="image/webp" />
        <img
          src="/images/hero.jpg"
          alt="Jóvenes estudiantes sonrientes"
          width="1200"
          height="1552"
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </picture>
    </div>

    <!-- Indicador de scroll -->
    <div class="wl-hero-scroll-hint" aria-hidden="true">
      <span>Scroll</span>
      <div class="wl-hero-scroll-line"></div>
    </div>

    <!-- Insignia flotante -->
    <div class="wl-hero-badge-float">
      <span class="wl-hero-badge-dot"></span>
      <div>
        <strong>Más de 5,000</strong>
        <small>estudiantes aprobados en México</small>
      </div>
    </div>

    <!-- Contenido -->
    <div class="wl-hero-body">
      <div class="container">
        <div class="wl-hero-content">
          <h1 class="wl-hero-title">
            <span class="wl-hero-line">
              <span class="wl-hero-line-inner">Tu aprobado en</span>
            </span>
            <span class="wl-hero-line">
              <span class="wl-hero-line-inner"><em class="wl-hero-serif">tu examen</em> de ingreso</span>
            </span>
            <span class="wl-hero-line">
              <span class="wl-hero-line-inner wl-hero-line-sub">
                comienza hoy a practicar con simuladores con contenido real como en los exámenes oficiales.
              </span>
            </span>
          </h1>

          <div class="wl-hero-divider"></div>

          <p class="wl-hero-desc">
            Practica con simuladores con contenido real como en los exámenes oficiales desde tu navegador — el EXANI
            para el ingreso a la universidad y los exámenes EGEL de CENEVAL para el egreso de carrera. Sin
            instalaciones, sin esperas.
          </p>

          <div class="wl-hero-pills">
            <span v-for="pill in heroPills" :key="pill.label" class="wl-hero-pill">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path v-for="(path, i) in pill.icon.split('|')" :key="i" :d="path" />
              </svg>
              {{ pill.label }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Barra de metricas -->
    <div class="wl-hero-stats-bar">
      <div v-for="stat in heroStats" :key="stat.title" class="wl-hero-stat-item">
        <div class="wl-hero-stat-ico" :class="stat.iconClass">
          <svg viewBox="0 0 24 24" fill="none" :stroke="stat.stroke" stroke-width="2">
            <path v-for="(path, i) in stat.icon.split('|')" :key="i" :d="path" />
          </svg>
        </div>
        <div class="wl-hero-stat-text">
          <div class="wl-hero-stat-title">{{ stat.title }}</div>
          <div class="wl-hero-stat-desc">{{ stat.description }}</div>
        </div>
      </div>
    </div>
  </section>
</template>
